    import Dexie from 'dexie'
    export let WebDB = null
    export let webDbAdapter = null
    export const initIndexDB = () =>
    {
        const callbackMap = {};
        class IndexdbData extends Dexie
        {
            constructor({tables})
            {
                const username = JSON.parse(localStorage.getItem('userInfo') || '{}')?.username || 'onecloud';
                const url = new URLSearchParams(top.document.location.href.split('?')?.[1] || '');
                const queryCollection = url.get('collection') || sessionStorage.getItem(`${username}_codigger_curCollection`);
                super(`${queryCollection || 'Collection1'}_${username}_codigger_web_db`)
                this.username = username;
                const schema = {}
                tables.forEach(ele =>
                {
                    schema[ele.name] = ele.schema
                })
                this.version(1).stores(schema);
            }
            async addTableItem({item, table})
            {
                try
                {
                    const res = await this[table].add(item)
                    this.emitChange({item, table});
                    return res
                }
                catch (error)
                {
                    if (error.name !== 'ConstraintError')
                    {
                        console.error(error);
                    }
                }
            }
            async updateTableItem({key, item, table})
            {
                try
                {
                    if (item == null)
                    {
                        return
                    }
                    const res = await this[table].update(key, item)
                    this.emitChange({key, item, table});
                    return res
                }
                catch (error)
                {
                    console.error(error);
                }
            }
            async bulkUpdateTable({table, items})
            {
                try {
                    const res = await this[table].bulkUpdate(items)
                    this.emitChange({table, items});
                    return res
                } catch (error) {
                    console.error(error);
                }
            }
            async deleteTableItem({key, table})
            {
                try
                {
                    const res = await this[table].delete(key)
                    this.emitChange({key, table});
                    return res
                }
                catch (error)
                {
                    console.error(error);
                }
            }
            async bulkPutTable({table, items})
            {
                try {
                    const res = await this[table].bulkPut(items)
                    this.emitChange({table, items});
                    return res
                } catch (error) {
                    console.error(error);
                }
            }
            async bulkDeleteTableItem({table, keys})
            {
                try
                {
                    const res = await this[table].bulkDelete(keys)
                    this.emitChange({table, keys});
                    return res
                }
                catch (error)
                {
                    console.error(error);
                }
            }
            async replaceTable({ table, items })
            {
                try
                {
                    const res = await this.transaction('rw', this[table], async() =>
                    {
                        await this[table].clear();
                        await this[table].bulkAdd(items);
                    })
                    this.emitChange({table, items});
                    return res;
                }
                catch(err)
                {
                    console.error(err)
                }
            }
            getTableItem({params, table})
            {
                return this[table].get(params);
            }
            getList({params, table})
            {
                if (params)
                {
                    return this[table].where(params).toArray()
                }
                return this[table].toArray()
            }
            addTableListener(table, callback)
            {
                if (!callbackMap[table])
                {
                    callbackMap[table] = []
                }
                callbackMap[table].push(callback);
                return this.removeTableListener.bind(this, table, callback);
            }
            removeTableListener(table, callback)
            {
                const fIndex = callbackMap[table].findIndex((i) => i === callback);
                if (fIndex !== -1)
                {
                    callbackMap[table].splice(fIndex, 1);
                }
            }
            emitChange(data)
            {
                callbackMap[data.table]?.forEach(callback=>callback?.(data))
            }
        }
        class StorageAdapter
        {
            constructor(db)
            {
                this.dbInstance = db
            }
            addTableItem(data)
            {
                return this.dbInstance.addTableItem(data)
            }
            updateTableItem(data)
            {
                return this.dbInstance.updateTableItem(data)
            }
            bulkUpdateTable(data)
            {
                return this.dbInstance.bulkUpdateTable(data)
            }
            deleteTableItem(data)
            {
                return this.dbInstance.deleteTableItem(data)
            }
            bulkDeleteTableItem(data)
            {
                return this.dbInstance.bulkDeleteTableItem(data)
            }
            replaceTable(data)
            {
                return this.dbInstance.replaceTable(data)
            }
            bulkPutTable(data)
            {
                return this.dbInstance.bulkPutTable(data)
            }
            getTableItem(data)
            {
                return this.dbInstance.getTableItem(data)
            }
            getList(data)
            {
                return this.dbInstance.getList(data)
            }
            getdb()
            {
                return this.dbInstance
            }
            addTableListener(data, callback)
            {
                return this.dbInstance.addTableListener(data, callback)
            }
        }
        class WebDBClass
        {
            type = "indexDB";
            constructor(options)
            {
                if (this.type === "indexDB")
                {
                    this.options = options;
                    this.db = new StorageAdapter(new IndexdbData(options));
                }
            }
            renew()
            {
                this.db = new StorageAdapter(new IndexdbData(this.options));
            }
        }
        WebDB = WebDBClass
        webDbAdapter = new WebDBClass({
            tables: [
                {
                    'name': 'sk_desktop_interface',
                    'schema': 'name,*background,*iconAlignment,*iconFontColor,*lookMode,*moduleName,*scaleMode,*scale,*ratio,*collection,*showSystemTray,*runningType,*theme,*timeMode,*windowStack'
                },
                {
                    'name': 'bind_desktop_interface',
                    'schema':'name,*homeDesktop,*linkDesktop,*moduleName,*workstationID'
                },
                {
                    'name': 'sk_desktop_general',
                    'schema':'name,*setting'
                },
                {
                    'name': 'app_shortcut',
                    'schema': 'id,*desktop,*appId,*appName,*appDesktopType,*createTime,*icon,*workstationId,*status'
                },
                {
                    'name': 'sk_collection_interface',
                    'schema': 'name,*id,*status,*desktopList'
                },
                {
                    'name': 'sk_desktop_switchboard',
                    'schema':'name,*value'
                },
                {
                    'name': 'desktop_desklet_config',
                    'schema':'id,*desktopInstance,*module_name,*version,*config,*naturalName,*logo'
                },
                {
                    'name': 'desktop_live_config',
                    'schema':'id,*desktopInstance,*type,*source_name,*module_name,*version,*config'
                },
                {
                    'name': 'desktop_icon_position',
                    'schema':'desktopInstance,*appId,*x,*y,*order,*zIndex,*width,*height'
                },
                {
                    'name': 'sizelook_config',
                    'schema':'name,*configs'
                },
                {
                    'name': "desktop_connectors",
                    'schema': "appId,*connectors"
                },
                {
                    'name': 'app_use_version',
                    'schema': 'appModuleName, *workstationVersion'
                },
                {
                    'name': 'desktop_builder_config',
                    'schema': 'desktop,*configs,*status'
                },
                {
                    'name': 'desktop_icon_shortcut',
                    'schema': 'id,*content,*desktopName,*iconImage,*iconType,*name,*silent,*type,*createTime'
                },
                {
                    'name': 'desktop_bg_cache',
                    'schema': 'id,*desktopName,*desktopBg,*base64,*blob,*createTime'
                },
                {
                    'name': 'quick_note_desktop_interface',
                    'schema': 'name,*fileName,*filePath,*editotContent'
                },
                {
                    'name': 'spitfire_history',
                    'schema': 'id,*user_name,*app,*version,*time,*data,*title,*icon_path,*pick'
                },
                {
                    'name': 'spitfire_download',
                    'schema': 'id,*user_name,*app,*version,*time,*fileName,*progress,*path,*ext'
                },
                {
                    'name': 'spitfire_favourite_folder',
                    'schema': 'id,*user_name,*app,*version,*time,*name,*parentId,*showChildren'
                },
                {
                    'name': 'spitfire_favourite_url',
                    'schema': 'id,*user_name,*app,*version,*time,*data,*title,*icon_path,*folderId'
                },
                {
                    'name': 'spitfire_icon_cache',
                    'schema': 'id,*hostname,*base64'
                },
                {
                    'name': 'app_info',
                    'schema': 'appid,*height,*maxStatus,*maximized,*position,*resizable,*width'
                },
                {
                    'name': 'anchor',
                    'schema': 'id,*parentEnv,*mudemId,*moduleName,*moduleEnvDestiny,*childEnv,*collection,*desktopName,*desktopModule,*workstationName,*workstationId,*moduleVersionId,*moduleVersion,*installPath,*displayName,*displayJson,*splashJson,*description,*icon,*corner,*position,*lastStatus,*extraData,*contextMenu,*taskbarMenu,*connector,*disconnector,*createSource,*cluster,*home,*place,*maxWidth,*minWidth,*maxHeight,*minHeight,*width,*height,*restore,*extendedUrl,*url,*resizable,*level,*catalog,*onMax,*enabled,*lastModified,*createTime'
                }
            ]
        })
    }
    initIndexDB()
    export default {
        WebDB,
        webDbAdapter
    };

